import React from "react";

const NailExtensionInLavelleDesign = () => {
  return (
    <div className="hairSalonInSahakaraWhat">
      <h3>Custom Designs to Suit Every Style</h3>
      <p>
        When you come to SCENT for nail extensions near Lavelle Road, our nail
        artists take the time to understand your style and preferences. We offer
        endless options for personalization, whether you want a classic French
        manicure, intricate nail art, or glitter embellishments. Here are a few
        of the popular styles we can create:
      </p>
      <li>
        <h6> French Manicures</h6>
        <p>
          This timeless look is perfect for anyone wanting a sophisticated and
          polished appearance. We can even add unique twists, such as colored or
          glitter tips, to make your French manicure stand out.
        </p>
      </li>
      <li>
        <h6>Ombre Nails</h6>
        <p>
          Soft and gradient, ombre nails add depth and style with a smooth blend
          of colors.
        </p>
      </li>
      <li>
        <h6> Glitter and Rhinestones</h6>
        <p>
          For a touch of glam, we can add glitter, metallic accents, or
          rhinestones to elevate your look. Our nail extensions near Lavelle
          Road include all these options to suit a variety of tastes.
        </p>
      </li>{" "}
      <li>
        <h6>Floral or Abstract Designs</h6>
        <p>
          Express your creativity with custom designs tailored to your
          preferences. Our nail artists can hand-paint detailed patterns that
          turn your nails into tiny works of art.
        </p>
      </li>
    </div>
  );
};

export default NailExtensionInLavelleDesign;
